import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class LoadingMaskService {
    private showLoading: boolean = false;
    public loadingChangedSubject: Subject<boolean[]>;
    private loadingWorkflow: boolean = false;
    private loadingPM: boolean = false;

    constructor() {
      this.loadingChangedSubject = new Subject<boolean[]>();
    }

  public setShowLoading(showLoading: boolean, loadWorkflow?: boolean, isCT?: boolean, loadPM?: boolean) {
    this.showLoading = showLoading;
    this.loadingWorkflow = loadWorkflow;
    this.loadingChangedSubject.next([this.showLoading, this.loadingWorkflow, isCT, loadPM]);
        
  }

    public getShowLoading(): boolean {
        return this.showLoading;
    }
}
